import { render, staticRenderFns } from "./NshopVaccountPayments.vue?vue&type=template&id=19044581&scoped=true&"
import script from "./NshopVaccountPayments.vue?vue&type=script&lang=js&"
export * from "./NshopVaccountPayments.vue?vue&type=script&lang=js&"
import style0 from "./NshopVaccountPayments.vue?vue&type=style&index=0&id=19044581&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19044581",
  null
  
)

export default component.exports